var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfElement04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1492,
    viewBox: "0 0 1920 1492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2293.94 1074.84C948.208 1168.25 488.522 1729.72 -107.264 1189.57C-583.893 757.456 -1623.35 896.487 -2083.5 1020.02",
    stroke: "url(#paint0_linear_1198_42708)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2296.03 1075.32C946.387 1124.38 452.861 1669.11 -108.969 1111.07C-558.433 664.636 -1605.02 769.207 -2072.13 877.296",
    stroke: "url(#paint1_linear_1198_42708)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2293.51 1073.72C942.217 1067.52 407.659 1591.22 -110.462 1011.08C-524.958 546.974 -1577.93 608.591 -2052.6 697.413",
    stroke: "url(#paint2_linear_1198_42708)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2285.86 1071.42C936.539 1017.79 368.089 1522.11 -111.202 924.46C-494.634 446.338 -1550.44 470.919 -2030.42 542.975",
    stroke: "url(#paint3_linear_1198_42708)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2303.82 1072.42C956.763 994.12 371.173 1487.89 -87.4439 881.656C-454.337 396.669 -1510.66 401.928 -1992.96 465.181",
    stroke: "url(#paint4_linear_1198_42708)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2306.54 1073.49C965.664 951.141 350.298 1425.23 -70.5744 804.581C-407.272 308.063 -1462.85 278.709 -1948.56 326.097",
    stroke: "url(#paint5_linear_1198_42708)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2304.44 1071.6C975.053 894.615 324.268 1342.8 -48.3104 705.919C-346.373 196.414 -1398.04 123.95 -1886.62 151.406",
    stroke: "url(#paint6_linear_1198_42708)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.45 1068.36C981.268 844.917 301.702 1269.74 -28.4757 620.513C-292.618 101.135 -1338.3 -8.16504 -1828.12 2.10732",
    stroke: "url(#paint7_linear_1198_42708)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2284.89 1107.58C941.259 1212.65 491.035 1777.01 -113.423 1243.23C-596.99 816.201 -1633.72 964.103 -2091.64 1091.43",
    stroke: "url(#paint8_linear_1198_42708)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2287.84 1108.27C939.11 1169.21 454.632 1718.25 -116.39 1165.21C-573.207 722.766 -1617.99 836.554 -2083.27 948.753",
    stroke: "url(#paint9_linear_1198_42708)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2285.29 1106.69C933.999 1112.4 408.144 1640.77 -119.537 1065.24C-541.681 604.819 -1593.55 675.713 -2066.72 768.712",
    stroke: "url(#paint10_linear_1198_42708)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2277.61 1104.45C927.501 1062.71 367.436 1572.01 -121.708 978.629C-513.023 503.921 -1568.35 537.806 -2047.1 614.087",
    stroke: "url(#paint11_linear_1198_42708)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2295.57 1105.29C947.324 1038.87 369.946 1537.77 -98.6671 935.619C-473.558 453.902 -1529.72 468.471 -2010.93 535.97",
    stroke: "url(#paint12_linear_1198_42708)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2298.32 1106.34C955.517 995.82 348.039 1475.3 -83.0706 858.403C-427.958 364.889 -1483.95 344.841 -1968.83 396.507",
    stroke: "url(#paint13_linear_1198_42708)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2296.18 1104.47C963.965 939.217 320.643 1393.1 -62.445 759.554C-368.916 252.714 -1421.71 189.524 -1909.8 221.284",
    stroke: "url(#paint14_linear_1198_42708)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2289.15 1101.29C969.362 889.464 296.875 1320.24 -44.0206 673.976C-316.737 156.964 -1364.15 56.8881 -1853.76 71.4769",
    stroke: "url(#paint15_linear_1198_42708)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1198_42708",
    x1: 105.219,
    y1: 896.269,
    x2: 105.219,
    y2: 1421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1198_42708",
    x1: 121.229,
    y1: 825.601,
    x2: 104.051,
    y2: 1349.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1198_42708",
    x1: 141.284,
    y1: 735.474,
    x2: 102.57,
    y2: 1259.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1198_42708",
    x1: 158.415,
    y1: 658.009,
    x2: 101.041,
    y2: 1181.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1198_42708",
    x1: 191.238,
    y1: 620.22,
    x2: 124.054,
    y2: 1143.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1198_42708",
    x1: 223.904,
    y1: 552.539,
    x2: 138.954,
    y2: 1075.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1198_42708",
    x1: 265.049,
    y1: 466.312,
    x2: 157.489,
    y2: 988.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1198_42708",
    x1: 300.311,
    y1: 392.184,
    x2: 172.875,
    y2: 913.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1198_42708",
    x1: 94.1288,
    y1: 948.655,
    x2: 98.7462,
    y2: 1472.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1198_42708",
    x1: 109.069,
    y1: 877.729,
    x2: 96.5141,
    y2: 1401.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1198_42708",
    x1: 127.631,
    y1: 787.434,
    x2: 93.5712,
    y2: 1311.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1198_42708",
    x1: 143.481,
    y1: 709.821,
    x2: 90.8096,
    y2: 1233.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1198_42708",
    x1: 175.669,
    y1: 671.747,
    x2: 113.22,
    y2: 1195.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1198_42708",
    x1: 207.217,
    y1: 603.784,
    x2: 127.071,
    y2: 1126.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1198_42708",
    x1: 246.928,
    y1: 517.203,
    x2: 144.285,
    y2: 1039.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1198_42708",
    x1: 280.964,
    y1: 442.766,
    x2: 158.561,
    y2: 964.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfElement04);
export default __webpack_public_path__ + "static/media/af_element_04.ba45b3c95b63e227de41b0c4af496a0a.svg";
export { ForwardRef as ReactComponent };